export default __webpack_public_path__ + "static/media/logo-dashboard.8abd3b7a.png";